const layout = () => import('../../internal/dashboard/layoutV2.vue')
const cadasterDriver = () => import('./cadasterDriverV2.vue')
const updateDriver = () => import('./updateDriver.vue')
const cadasterDriverRandom = () => import('./cadasterDriverRandom.vue')
const updateDriverRandom  = () => import('./updateDriverRandom.vue')

const cadasterDriverRoutes = {
  component: layout,
  children: [
    {
      path: '/cadasterDriver',
      name: 'cadasterDriver',
      meta: {
        title: 'cadasterDriver',
        requiresAuth: true,
      },
      component: cadasterDriver,
    },
    {
      path: '/updateDriver/:id',
      name: 'updateDriver',
      meta: {
        title: 'updateDriver',
        requiresAuth: true,
      },
      component: updateDriver,
    },
    {
      path: '/updateDriver/random/:id',
      name: 'updateDriverRandom',
      meta: {
        title: 'updateDriverRandom',
        requiresAuth: true,
      },
      component: updateDriverRandom,
    },
    {
      path: '/cadasterDriver/random',
      name: 'cadasterDriverRandom',
      meta: {
        title: 'cadasterDriverRandom',
        requiresAuth: true,
      },
      component: cadasterDriverRandom,
    },
  ],
}

export default cadasterDriverRoutes
